import { CapoPlugin } from "/home/runner/work/qtp/qtp/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];